// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect} from 'react';
import {Hero} from '../../ui/location/hero';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import country from '/util/country.js';
import {Why_oculus} from '../../ui/homepage/why_oculus';
import {Use_cases} from '../../ui/homepage/use_cases';
import {Products} from '../../ui/homepage/products';
import {Reviews} from '../../ui/homepage/reviews';
import {Top_locations} from '../../ui/common/top_locations';
import {HP_faq} from '../../ui/homepage/faq';
import {use_scroll_to_top} from '../../ui/common/use_scroll_to_top';
import {perr_www_visit} from 'hola_pub_util';
import {prepare_continent_data} from '../../../../toolip/pub/ui/location/top_locations';

export const Root = ()=>{
    const {params} = use_pathname();
    const location_name = params['proxy-location'];
    const us_region_name = params['united-states'];
    const detected_location_name = !location_name &&
        us_region_name ? 'united-states' : location_name;
    const not_landing = !country
        .get_location_info(detected_location_name)?.type;
    useEffect(()=>{
        perr_www_visit({id: 'oculus_proxy_location_visit'});
    }, []);
    use_scroll_to_top();

    return <div>
      <Hero country={detected_location_name} region={us_region_name} />
      <Top_locations country={detected_location_name}/>
      <Why_oculus/>
      <Use_cases/>
      <Products/>
      {not_landing && <Reviews/>}
      {not_landing && <HP_faq country={detected_location_name}/>}
      {!not_landing && <HP_faq title={'Our Global Proxies'}
        get_questions={prepare_continent_data}/>}
    </div>;
};

const location_descriptions = {
    'sweden': 'Sweden proxies with real Swedish IPs for sneaker sites, '+
        'ticketing platforms, and e-commerce. Fast speeds and reliable '+
        'uptime. Start your free trial.',
    'moldova': 'Moldova proxies with authentic local IPs for geo-restricted '+
        'access and automated tasks. Reliable residential connections. '+
        'Start your free trial today.',
    'africa': 'Africa proxies with IPs across 15+ African countries for '+
        'regional sneaker drops and e-commerce access. Residential and '+
        'datacenter options. Try free.',
    'chile': 'Chile proxies with authentic Chilean IPs for South American '+
        'sneaker releases and regional e-commerce. Fast, reliable '+
        'connections. Start free today.',
    'indonesia': 'Indonesia proxies with genuine local IPs for Southeast '+
        'Asian markets and geo-restricted platforms. Fast residential '+
        'proxies. Start your free trial.',
    'switzerland': 'Switzerland proxies with Swiss IPs for European sneaker '+
        'sites and secure e-commerce automation. High-speed residential '+
        'options. Try risk-free today.',
    'estonia': 'Estonia proxies with Baltic IP addresses for EU sneaker '+
        'drops and ticketing platforms. Fast, reliable residential '+
        'connections. Start your free trial.',
    'finland': 'Finland proxies with authentic Finnish IPs for Nordic '+
        'sneaker releases and EU e-commerce access. Reliable speeds and '+
        'uptime. Start your free trial.',
    'ireland': 'Ireland proxies with genuine Irish IPs for UK and EU '+
        'sneaker sites and ticketing platforms. Fast residential '+
        'connections. Start your free trial today.',
    'mexico': 'Mexico proxies with real Mexican IPs for LATAM sneaker drops '+
        'and regional e-commerce platforms. Fast, reliable residential '+
        'options. Try free today.',
    'luxembourg': 'Luxembourg proxies with local IPs for European sneaker '+
        'releases and e-commerce automation. Reliable residential '+
        'connections. Start your free trial.',
    'brazil': 'Brazil proxies with authentic Brazilian IPs for South '+
        'American sneaker sites and e-commerce platforms. Fast residential '+
        'speeds. Start free today.',
    'de': 'Germany proxies with real German IPs for EU sneaker drops, '+
        'Adidas, and European ticketing sites. High-speed residential '+
        'options. Try risk-free today.',
    'algeria': 'Algeria proxies with North African IPs for MENA region '+
        'access and geo-restricted platforms. Reliable residential '+
        'connections. Start your free trial.',
    'russia': 'Russia proxies with authentic Russian IPs for regional '+
        'sneaker releases and e-commerce platforms. Fast, reliable '+
        'residential speeds. Try free today.',
    'turkey': 'Turkey proxies with genuine Turkish IPs for regional sneaker '+
        'drops and e-commerce automation. Fast residential connections. '+
        'Start your free trial.',
    'andorra': 'Andorra proxies with authentic local IPs for European '+
        'geo-restricted access and e-commerce platforms. Reliable '+
        'residential options. Try free today.',
    'slovenia': 'Slovenia proxies with Slovenian IPs for Central European '+
        'sneaker sites and e-commerce access. Fast residential connections. '+
        'Start your free trial.',
    'albania': 'Albania proxies with genuine local IPs for Balkan region '+
        'access and geo-restricted platforms. Reliable residential '+
        'connections. Start free today.',
    'slovak-republic': 'Slovak Republic proxies with local IPs for Central '+
        'European sneaker drops and e-commerce. Fast residential '+
        'connections. Start your free trial today.',
    'portugal': 'Portugal proxies with authentic Portuguese IPs for Iberian '+
        'sneaker releases and EU e-commerce platforms. Reliable speeds. '+
        'Start your free trial.',
    'isle-of-man': 'Isle of Man proxies with British Isles IPs for UK '+
        'sneaker sites and ticketing platforms. Reliable residential '+
        'connections. Start your free trial.',
    'greece': 'Greece proxies with genuine Greek IPs for Mediterranean '+
        'sneaker drops and EU e-commerce access. Fast residential speeds. '+
        'Start your free trial today.',
    'greenland': 'Greenland proxies with Arctic region IPs for unique '+
        'geo-targeting and Nordic platform access. Reliable residential '+
        'connections. Start free today.',
    'poland': 'Poland proxies with real Polish IPs for Central European '+
        'sneaker releases and e-commerce automation. Fast residential '+
        'speeds. Try risk-free today.',
    'liechtenstein': 'Liechtenstein proxies with Swiss-region IPs for '+
        'European sneaker sites and secure e-commerce access. Reliable '+
        'residential options. Try free today.',
    'norway': 'Norway proxies with authentic Norwegian IPs for Scandinavian '+
        'sneaker drops and Nordic e-commerce. Fast residential connections. '+
        'Start free today.',
    'north-america': 'North America proxies with US and Canadian IPs for '+
        'Nike, Footlocker, and major ticketing sites. Fast residential and '+
        'datacenter options. Try free.',
    'argentina': 'Argentina proxies with authentic local IPs for South '+
        'American sneaker releases and LATAM e-commerce platforms. Reliable '+
        'speeds. Start free today.',
    'germany': 'Germany proxies with real German IPs for Adidas, EU sneaker '+
        'drops, and European ticketing platforms. High-speed residential '+
        'options. Try free today.',
    'united-kingdom': 'UK proxies with genuine British IPs for Footlocker '+
        'UK, Size?, and EU sneaker releases. Fast residential connections '+
        'for copping. Start free today.',
    'great-britain': 'UK proxies with genuine British IPs for Footlocker '+
        'UK, Size?, and EU sneaker releases. Fast residential connections '+
        'for copping. Start free today.',
    'croatia-(hrvatska)': 'Croatia proxies with Adriatic IPs for Balkan and '+
        'EU sneaker access and e-commerce platforms. Reliable residential '+
        'connections. Start your free trial.',
    'czech-republic': 'Czech Republic proxies with local IPs for Central '+
        'European sneaker drops and e-commerce automation. Fast residential '+
        'speeds. Start free today.',
    'netherlands': 'Netherlands proxies with Dutch IPs for EU sneaker '+
        'releases, ticketing sites, and e-commerce automation. Fast '+
        'residential speeds. Try risk-free today.',
    'egypt': 'Egypt proxies with authentic Egyptian IPs for MENA region '+
        'access and geo-restricted platforms. Reliable residential '+
        'connections. Start free today.',
    'south-africa': 'South Africa proxies with local IPs for African '+
        'sneaker drops and regional e-commerce platforms. Fast residential '+
        'connections. Start your free trial.',
    'vietnam': 'Vietnam proxies with genuine Vietnamese IPs for Southeast '+
        'Asian markets and e-commerce platforms. Fast residential '+
        'connections. Start free today.',
    'saudi-arabia': 'Saudi Arabia proxies with Gulf region IPs for MENA '+
        'sneaker releases and regional e-commerce access. Reliable '+
        'residential speeds. Try free today.',
    'hungary': 'Hungary proxies with authentic Hungarian IPs for Central '+
        'European sneaker sites and e-commerce access. Fast residential '+
        'connections. Try free today.',
    'belgium': 'Belgium proxies with genuine Belgian IPs for EU sneaker '+
        'drops and European ticketing platforms. Reliable residential '+
        'connections. Start free today.',
    'ukraine': 'Ukraine proxies with real Ukrainian IPs for Eastern '+
        'European sneaker access and e-commerce platforms. Fast residential '+
        'connections. Try free today.',
    'cyprus': 'Cyprus proxies with Mediterranean IPs for EU sneaker '+
        'releases and regional e-commerce platforms. Reliable residential '+
        'connections. Start free today.',
    'bermuda': 'Bermuda proxies with Caribbean IPs for regional '+
        'geo-targeting and unique platform access. Reliable residential '+
        'connections. Start your free trial today.',
    'latin-america': 'Latin America proxies with IPs across 20+ LATAM '+
        'countries for regional sneaker drops and e-commerce. Residential '+
        'and datacenter options. Try free.',
    'italy': 'Italy proxies with authentic Italian IPs for EU sneaker '+
        'releases, Foot Locker EU, and ticketing platforms. Fast '+
        'residential speeds. Try free today.',
    'morocco': 'Morocco proxies with North African IPs for MENA region '+
        'access and geo-restricted platforms. Reliable residential '+
        'connections. Start your free trial.',
    'us': 'US proxies with American IPs for Nike, Footlocker, Supreme, and '+
        'major ticketing sites. Fast residential and datacenter options. '+
        'Start free today.',
    'united-states': 'US proxies with American IPs for Nike, Footlocker, '+
        'Supreme, and major ticketing sites. Fast residential and '+
        'datacenter options. Start free today.',
    'macedonia': 'Macedonia proxies with Balkan IPs for regional sneaker '+
        'access and European e-commerce platforms. Reliable residential '+
        'connections. Start free today.',
    'austria': 'Austria proxies with genuine Austrian IPs for DACH region '+
        'sneaker drops and EU e-commerce access. Fast residential '+
        'connections. Try risk-free today.',
    'serbia': 'Serbia proxies with authentic Serbian IPs for Balkan region '+
        'sneaker access and e-commerce platforms. Reliable residential '+
        'speeds. Start free today.',
    'bailiwick-of-jersey': 'Jersey proxies with Channel Islands IPs for UK '+
        'sneaker sites and European platform access. Reliable residential '+
        'connections. Start your free trial.',
    'denmark': 'Denmark proxies with authentic Danish IPs for Scandinavian '+
        'sneaker releases and Nordic e-commerce. Fast residential '+
        'connections. Start free today.',
    'belarus': 'Belarus proxies with local IPs for Eastern European '+
        'geo-targeting and regional platform access. Reliable residential '+
        'connections. Start free today.',
    'montenegro': 'Montenegro proxies with Adriatic IPs for Balkan region '+
        'access and European e-commerce platforms. Reliable residential '+
        'connections. Try free today.',
    'bulgaria': 'Bulgaria proxies with genuine Bulgarian IPs for Balkan '+
        'sneaker access and EU e-commerce platforms. Fast residential '+
        'connections. Start free today.',
    'ca': 'Canada proxies with real Canadian IPs for North American sneaker '+
        'drops, Footlocker CA, and ticketing sites. Fast residential '+
        'speeds. Try free today.',
    'canada': 'Canada proxies with real Canadian IPs for North American '+
        'sneaker drops, Footlocker CA, and ticketing sites. Fast '+
        'residential speeds. Try free today.',
    'fr': 'France proxies with authentic French IPs for EU sneaker '+
        'releases, Courir, and European ticketing platforms. Fast '+
        'residential speeds. Try free today.',
    'asia': 'Asia proxies with IPs across 30+ Asian countries for regional '+
        'sneaker releases and e-commerce access. Residential and datacenter '+
        'options. Try free.',
    'china': 'China proxies with authentic Chinese IPs for Asian market '+
        'access and regional e-commerce platforms. Fast, reliable '+
        'residential connections. Try free.',
    'tunisia': 'Tunisia proxies with North African IPs for MENA region '+
        'access and geo-restricted platforms. Reliable residential '+
        'connections. Start your free trial.',
    'india': 'India proxies with genuine Indian IPs for South Asian '+
        'e-commerce and regional platform access. Fast residential '+
        'connections. Start your free trial.',
    'colombia': 'Colombia proxies with authentic Colombian IPs for LATAM '+
        'sneaker drops and South American e-commerce. Reliable residential '+
        'speeds. Start free today.',
    'france': 'France proxies with real French IPs for EU sneaker releases, '+
        'Courir, and European ticketing sites. Fast residential '+
        'connections. Try risk-free today.',
    'europe': 'Europe proxies with IPs across 40+ EU countries for regional '+
        'sneaker drops and ticketing platforms. Residential and datacenter '+
        'options. Try free.',
    'iceland': 'Iceland proxies with authentic Nordic IPs for Scandinavian '+
        'sneaker access and EU e-commerce platforms. Reliable residential '+
        'speeds. Try free today.',
    'kosovo': 'Kosovo proxies with Balkan IPs for regional geo-targeting '+
        'and European platform access. Reliable residential connections. '+
        'Start your free trial today.',
    'bosnia-and-herzegovina': 'Bosnia and Herzegovina proxies with Balkan '+
        'IPs for regional access and EU e-commerce platforms. Reliable '+
        'residential connections. Start free today.',
    'spain': 'Spain proxies with genuine Spanish IPs for Iberian sneaker '+
        'releases and EU e-commerce platforms. Fast residential '+
        'connections. Start free today.',
    'oceania': 'Oceania proxies with IPs from Australia, New Zealand, and '+
        'Pacific islands for regional access. Fast residential connections. '+
        'Start your free trial.',
    'australia': 'Australia proxies with genuine Australian IPs for APAC '+
        'sneaker releases and regional e-commerce. Fast residential '+
        'connections. Start free today.',
    'japan': 'Japan proxies with authentic Japanese IPs for Asian sneaker '+
        'drops and regional e-commerce platforms. Fast residential speeds. '+
        'Start your free trial.',
};

const meta = {
    meta: props=>{
        const us_region_name = props?.params?.['united-states'] || '';
        const param = props?.params?.['proxy-location'] || '';
        let title, description, canonical_url;

        if (!param && us_region_name)
        {
            const region_info = country.us_state_zip_list
                .find(state_item=>{
                    return state_item.name.toLowerCase() === us_region_name;
                });
            if (region_info)
            {
                title = `${region_info.name} Proxies | Oculus`;
                description =
                    `Try ${region_info.name} proxies with a free trial.`;
                canonical_url =
                    `https://oculusproxies.com/proxy-location/${us_region_name}`;
                return {title, description, canonical_url};
            }
            title = 'Proxy IP Servers in Any Location | Oculus';
            description = 'Browse available proxy locations by country and '+
              'region. Unlock geo-targeted access with residential, ISP, and '+
              'datacenter IPs worldwide.';
            canonical_url = 'https://oculusproxies.com/proxy-location/';
            return {title, description, canonical_url};
        }
        if (!param)
        {
            title = 'Proxy IP Servers in Any Location | Oculus';
            description = 'Browse available proxy locations by country and '+
              'region. Unlock geo-targeted access with residential, ISP, and '+
              'datacenter IPs worldwide.';
            canonical_url = 'https://oculusproxies.com/proxy-location/';
        }
        else
        {
            const normalized_param = country.normalize_location_url(param) ||
                param;
            const country_name = country.get_location_display_name(
                normalized_param) ||
                normalized_param.replace(/-/g, ' ');
            title = `${country_name} Proxies | Oculus`;
            description = location_descriptions[param] ||
                location_descriptions[normalized_param] ||
                `${country_name} proxies with local IPs for geo-restricted `+
                'access and e-commerce platforms. Reliable residential '+
                'connections. Start your free trial today.';
            canonical_url = `https://oculusproxies.com/proxy-location/${
                normalized_param}`;
        }
        return {title, description, canonical_url};
    },
    no_ssr: false,
    ssr_force: true,
};

Root.meta = meta;
